<app-page-title title="Alterar senha"></app-page-title>
<div class="form-container">
  <form [formGroup]="form">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Senha atual</mat-label>
      <input
        matInput
        formControlName="password"
        type="password"
        id="current-passowrd"
        autocomplete="current-password"
      />
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nova senha</mat-label>
      <input
        matInput
        #newPassword
        formControlName="newPassword"
        type="password"
        id="new-passowrd"
        autocomplete="new-password"
      />
      <mat-error *ngIf="form.controls.newPassword.hasError('required')"> Senha obrigatorio! </mat-error>
      <mat-error *ngIf="form.controls.newPassword.hasError('minlength')"> Senha muito pequena! </mat-error>
      <mat-error *ngIf="form.controls.newPassword.hasError('maxlength')"> Senha muito grande! </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Repita a nova senha</mat-label>
      <input matInput #newPasswordReply formControlName="newPasswordReply" type="password" />
      <mat-error *ngIf="newPassword.value !== newPasswordReply">Confirmação incorreta</mat-error>
    </mat-form-field>

    <p>
      <button class="btn-primary" mat-raised-button (click)="save()">Salvar</button>
    </p>
  </form>
</div>
